import styled from "styled-components";

import { LogoContainer } from "../Navbar/styles";

import { size } from "~/styles/screen";

export const LinkListsContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: ${size.small}) {
    & {
      flex-direction: column;
    }
  }
`;

export const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  width: 33%;
  @media screen and (max-width: ${size.small}) {
    & {
      width: 100%;
    }
  }
`;

export const LinkListTitle = styled.div`
  font-size: 14px;
  color: #e0e0e2;
  margin-bottom: 10px;
  letter-spacing: 1px;
  font-weight: 500;
  margin-top: 10px;
`;

export const Copyright = styled.div`
  color: #fff;
  font-size: 12px;
  font-family: "Open Sans";
  font-weight: 600;
`;

export const LogoContainerFooter = styled(LogoContainer)`
  width: 100px;
  height: unset;
  padding: 5px;
  margin-top: 20px;
`;

export const SocialImage = styled.img`
  width: 30px;
  margin: 5px;
  margin-top: 20px;
`;

export const Link = styled.a`
  font-size: 14px;
  margin-bottom: 10px;
  color: #fff;
  font-weight: 700;
  font-family: "Open Sans";
  letter-spacing: 2px;
  &:hover {
    color: #fff;
  }
`;
